import sliceCreator from '../../index.jsx';
import {GET_ALL_USERS} from '../../../constants/index.jsx';
const _getAllUserAction = sliceCreator('GET_ALL_USERS', GET_ALL_USERS, 'get');

const { asyncAction: getAllUserAction, reducer, clearData: clearGetAllUserAction } = _getAllUserAction;

export default reducer;

export {
    getAllUserAction,
    clearGetAllUserAction
}